import { loadElementLazyImage } from '../helpers/lazy-load'

let featuredServicesBlockClass = '.feature-services-block'
let featuredServicesBlocks = $(featuredServicesBlockClass)

if (featuredServicesBlocks){
  let menuEl = $('.js-service-menuel')
  let prevArr = featuredServicesBlocks.find('.arrow-up')
  let nextArr = featuredServicesBlocks.find('.arrow-down')

  menuEl.click(function(){
    let slider = $(this).closest(featuredServicesBlockClass)
    let nextSlide = $(this).data('slide')

    goToServiceSlide(slider, nextSlide)
  })
  prevArr.click(function(){
    let slider = $(this).closest(featuredServicesBlockClass)
    let curSlide = slider.attr('data-cur-slide')
    curSlide--
    if (curSlide >= 0) goToServiceSlide(slider, curSlide)
  })
  nextArr.click(function(){
    let slider = $(this).closest(featuredServicesBlockClass)
    let slides = slider.find('.js-opened-service')
    let curSlide = slider.attr('data-cur-slide')
    curSlide++
    if (curSlide < slides.length) goToServiceSlide(slider, curSlide)
  })

  function goToServiceSlide(slider, nextSlide){
    let $slides = slider.find('.js-opened-service')
    let $nextSlide = slider.find('.js-opened-service[data-slide="'+ nextSlide +'"]')
    let $menuEls = slider.find('.js-service-menuel')
    let $menuEl = slider.find('.js-service-menuel[data-slide="'+ nextSlide +'"]')
    let $prevArr = slider.find('.arrow-up')
    let $nextArr = slider.find('.arrow-down')

    loadElementLazyImage($nextSlide.find('.lazy'))

    $prevArr.removeClass('disabled')
    $nextArr.removeClass('disabled')
    if (nextSlide === $slides.length - 1) $nextArr.addClass('disabled')
    if (nextSlide === 0) $prevArr.addClass('disabled')

    $slides.css('display', 'none')
    $nextSlide.fadeIn()

    $menuEls.removeClass('js-active')
    $menuEl.addClass('js-active')

    slider.attr('data-cur-slide', nextSlide)
  }


}

// responsive accordion functionality
if (window.innerWidth < 1200){

  let accordionH = $('.js-service-menu-el')

  accordionH.click(function(){
    let service = $(this).closest('.service')
    let serviceMenu = $(this).closest('.services-menu')

    accordionH.parent().removeClass('js-active')
    $(this).parent().addClass('js-active')

    serviceMenu.find('.opened-service').slideUp()
    service.find('.opened-service').slideDown(400)

  })

}
